module.exports = __webpack_public_path__ + "img/icon-clock.3bac83e3.svg";